import { ZfBox, ZfDivider, ZfIcon, ZfPopover, ZfStack, ZfTypography } from '@zafire/react';
import React from 'react';

type SectionBlockType = {
  list: { label: string; value?: string; info?: string; testId?: string }[];
};

export const SectionBlock = ({ list }: SectionBlockType) => {
  return (
    <ZfStack direction="column" spacing="extra-extra-small">
      {list.map((item, index) => (
        <React.Fragment key={`${item.label}-${index}`}>
          <ZfStack direction="row" justify="space-between" style={{ padding: '4px 0' }}>
            {item.info ? (
              <ZfBox style={{ display: 'flex', gap: '12px' }}>
                <ZfTypography variant="label-medium" color="muted">
                  {item.label}
                </ZfTypography>
                <ZfPopover>
                  <ZfIcon slot="anchor" size="medium" name="info" style={{ cursor: 'pointer' }}></ZfIcon>
                  <ZfBox styles={{ textWrap: 'wrap' }}>
                    <ZfTypography variant="label-tiny" color="normal">
                      {item.info}
                    </ZfTypography>
                  </ZfBox>
                </ZfPopover>
              </ZfBox>
            ) : (
              <ZfTypography variant="label-medium" color="muted">
                {item.label}
              </ZfTypography>
            )}
            <ZfTypography variant="body-medium" data-testid={item.testId}>
              {item.value}
            </ZfTypography>
          </ZfStack>
          <ZfDivider />
        </React.Fragment>
      ))}
    </ZfStack>
  );
};
